export const enum AppRoutes {
    LandingPage = '/login',
    SettingsPage = '/settings',
    HomePage = '/',
    LogoutPage = '/logout',
    CookiesPage = '/cookies',
    TandC = '/tandc',
    PrivacyPage = '/privacy',
    AccessibilityStatement = '/accessibility',
    Unauthorized = '/403',
    Management = '/admin/management',
    Tenant = '/admin/management/tenant',
    ApplicationPolicies = '/admin/applicationPolicies',
    BusinessMetrics = '/admin/businessMetrics',
    CreateDeclaration = '/create-declaration',
    EditDeclaration = '/:declarationType/:submissionId/edit',
    History = '/history',
}

export const LoginRedirectStorageKey = 'returnRoute';
